/**
 * @ngdoc controllers
 * @memberof mercury.modules.time
 * @name TimePayrunReviewCtrl
 */
angular.module('mercury.modules.time.payroll.payrun')
.controller('PayrollPayrunReviewCtrl', ["dialog", "$filter", "$scope", "$state", "$stateParams", "TimePayrollPayruns", "TimeStaff", "title", function(dialog, $filter, $scope, $state, $stateParams, TimePayrollPayruns, TimeStaff, title) {
  title.set('Payrun Review');

  $scope.totalWages = 0;
  $scope.totalSalary = 0;
  $scope.totalTaxables = {};
  $scope.totalNontaxables = {};

  var addTotals = function(payrunLine) {
    angular.forEach(payrunLine.wagePaytypes, function(paytypeLine) {
      if (paytypeLine.paytypeAbbrev == 'SALARY') {
        $scope.totalSalary += paytypeLine.rate * paytypeLine.quantity;
      } else {
        $scope.totalWages += paytypeLine.rate * paytypeLine.quantity;
      }
    });

    angular.forEach(payrunLine.taxableLines, function(paytypeLine) {
      if ($scope.totalTaxables[paytypeLine.paytypeId]) {
        $scope.totalTaxables[paytypeLine.paytypeId].cost += paytypeLine.rate * paytypeLine.quantity;
      } else {
        $scope.totalTaxables[paytypeLine.paytypeId] = {
          name: paytypeLine.paytypeName,
          cost: paytypeLine.rate * paytypeLine.quantity
        };
      }
    });

    angular.forEach(payrunLine.nonTaxableLines, function(paytypeLine) {
      if ($scope.totalNontaxables[paytypeLine.paytypeId]) {
        $scope.totalNontaxables[paytypeLine.paytypeId].cost += paytypeLine.rate * paytypeLine.quantity;
      } else {
        $scope.totalNontaxables[paytypeLine.paytypeId] = {
          name: paytypeLine.paytypeName,
          cost: paytypeLine.rate * paytypeLine.quantity
        };
      }
    });
  };

  $scope.loading = TimePayrollPayruns.get($stateParams.id);
  $scope.loading.then(function(result) {
    $scope.payrun = result;

    angular.forEach($scope.payrun.lines, function(payrunLine) {
      payrunLine.wagePaytypes = $filter('filter')(payrunLine.paytypes, {paytypeModule: 0});
      payrunLine.taxableLines = $filter('filter')(payrunLine.paytypes, {paytypeModule: '!0', paytypeIsTaxable: true});
      payrunLine.nonTaxableLines = $filter('filter')(payrunLine.paytypes, {paytypeModule: '!0', paytypeIsTaxable: false});

      addTotals(payrunLine);
    });
  });

  $scope.approvePayrun = function() {
    $scope.approving = TimePayrollPayruns.approve($scope.payrun);
    $scope.approving.then(function() {
      $state.go('Time.Payroll.PayrunOutstanding');
    });
  };

  $scope.export = function() {
    $scope.unExportedStaff = $filter('filter')($scope.payrun.lines, {staffMemberIsExported: false});

    //If we have unexported staff, prompt the user for whether to include them in the payrun export.
    if ($scope.unExportedStaff.length > 0) {
      //Ensure that all staff that will be exported, have a payroll code set.
      dialog.open({
        templateUrl: 'modules/time/payroll/payrun/exportconfirm.tpl.html',
        scope: $scope
      })
      .then(function(includeStaff) {
        $scope.exporting = TimePayrollPayruns.downloadExport($stateParams.id, includeStaff);

        angular.forEach($scope.payrun.lines, function(payrunLine) {
          payrunLine.staffMemberIsExported = true;
        });
      });
    } else {
      $scope.exporting = TimePayrollPayruns.downloadExport($stateParams.id, false);
    }
  };

  $scope.updateStaffPaycode = function(payrunLine) {
    TimeStaff.updatePaycode(payrunLine.staffMemberId, payrunLine.staffMemberPayCode);
  };

  $scope.isStaffExportValid = function() {
    var noPaycodes = $filter('filter')($scope.unExportedStaff, function(line) {
      return line.staffMemberPayCode === '' || line.staffMemberPayCode === null;
    });

    return noPaycodes.length === 0;
  };
}]);
